import { NumberFormatToNode } from "../../../../../../global"
import { ParseToNumber } from "../../../../utils/tools"

import { 
  InputSeletora, 
  OutputVazaoDest, 
  OutputVazaoFab,
  InputMelFinal,
  OutputMelFinal,
  InputLogicFabrica,
  InputLogicDestilaria,
  OutputMosto,
  InputAjustCaldoVazaoDest,
  InputAjustCaldoBrixDest,
  InputAjustCaldoBrixFab
} from "../fixedCurrents"

const LogicDistilleryAndFactory = {
  Apply(inputsToSend){
    try {
      let vazFab = OutputVazaoFab()
      let vazDest = OutputVazaoDest()
      let outputMosto = OutputMosto()

      let selectNode = inputsToSend.find(input => input.isEquals(InputSeletora()))
      if(!selectNode.index) return 

      let inputMelNode = inputsToSend.filter(input => input.isEquals(InputMelFinal()))
      let outputMelNode = inputsToSend.find(input => input.isEquals(OutputMelFinal()))
      let inputLogicFabricaNode = inputsToSend.filter(input => input.isEquals(InputLogicFabrica()))
      let inputLogicDestilariaNode = inputsToSend.filter(input => input.isEquals(InputLogicDestilaria()))

      let inputAjustCaldoVazaoDestNode = inputsToSend.filter((input) =>{
        return input.isEquals(InputAjustCaldoVazaoDest())
      })

      let inputAjustCaldoBrixDest = inputsToSend.filter(input => input.isEquals(InputAjustCaldoBrixDest()))
      let inputAjustCaldoBrixFab = inputsToSend.filter(input => input.isEquals(InputAjustCaldoBrixFab()))
      
      // Lógica para 1 = Fábrica, 2 = Destilaria
      if (selectNode.value == "1,00") {
        if(inputMelNode.length && outputMelNode) {
          let value = ParseToNumber(inputMelNode[0].value) * (-1)
          outputMelNode.value = NumberFormatToNode(value)
        }
        this.setValue(inputLogicDestilariaNode, vazDest)
        this.setValue(inputAjustCaldoVazaoDestNode, outputMosto)
        this.setValue(inputAjustCaldoBrixDest, inputAjustCaldoBrixFab[0])
      } else {
        if(outputMelNode && inputMelNode) {
          let value = ParseToNumber(outputMelNode.value) * (-1)
          inputMelNode.forEach(e => {
            e.value = NumberFormatToNode(value)
          });
        }
        this.setValue(inputLogicFabricaNode, vazFab)
        this.setValue(inputAjustCaldoBrixFab, inputAjustCaldoBrixDest[0])
      }
    } catch(e) {
      console.warn(`Falha aos receber os dados em LogicDistilleryAndFactory. \nErro: ${e}` );
    }
  },
  setValue(propTarget, propSource) {
    if(propTarget && propSource) {
      propTarget.forEach(e => {
        e.value = propSource.value
      });
    }
  }
}

export default LogicDistilleryAndFactory